import React from 'react';

const GpsAddressSearch = ({
  value,
  onValueChange,
  onSearch,
  loading,
  placeholder = "123 Main St, City, State",
}) => {
  return (
  <div className="w-full">
    <form
      className="w-full"
      onSubmit={(e) => {
        e.preventDefault();
        if (onSearch) onSearch();
      }}
    >
      <div className="flex w-full flex-row items-center gap-2">
        <input
          id="gps-address"
          name="gpsAddress"
          type="text"
          placeholder={placeholder}
          className="w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-200"
          spellCheck={false}
          value={value}
          onChange={(e) => onValueChange?.(e.target.value)}
          style={{ flex: "1 1 0%", minWidth: "50%" }}
        />

        <button
          className="rounded-lg bg-gray-900 px-3 py-2 text-xs font-semibold text-white hover:bg-gray-800 disabled:opacity-60"
          type="submit"
          disabled={loading}
        >
          {loading ? "..." : "Go"}
        </button>
      </div>
    </form>
  </div>
  );
};

export default GpsAddressSearch;
